<template>
  <div class="reporting-container">
    <div class="reporting-title">举报入口</div>
    <div class="reporting-list">
      <div class="reporting-list-item" v-for="(item,index) in typeList" :key="item.id" @click="toReportInstructions(item.id)">
        <img :src="item.img" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import type1 from '@/assets/img/type-1.png'
import type2 from '@/assets/img/type-2.png'
import type3 from '@/assets/img/type-3.png'
import type4 from '@/assets/img/type-4.png'
import type5 from '@/assets/img/type-5.png'
import type6 from '@/assets/img/type-6.png'
import type7 from '@/assets/img/type-7.png'
import type8 from '@/assets/img/type-8.png'
import type9 from '@/assets/img/type-9.png'

export default {
  components: {},
  props: {},
  data() {
    return {
      typeList:[
                {
                    typeName:"政治类",
                    img:type1,
                    id:1,
                },
                {
                    typeName:"暴恐类",
                    img:type2,
                    id:2,
                },
                {
                    typeName:"诈骗类",
                    img:type3,
                    id:3,
                },
                {
                    typeName:"色情类",
                    img:type4,
                    id:4,
                },
                {
                    typeName:"低俗类",
                    img:type5,
                    id:5,
                },
                {
                    typeName:"赌博类",
                    img:type6,
                    id:6,
                },
                {
                    typeName:"侵权类",
                    img:type7,
                    id:7,
                },
                {
                    typeName:"谣言类",
                    img:type8,
                    id:8,
                },
                {
                    typeName:"其他类",
                    img:type9,
                    id:0,
                }
          ],
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
        toReportInstructions(id){
          if(window.location.href.startsWith('http://localhost') || window.location.href.startsWith('https://piyao-web.fm-dev')){
            window.open(`https://jb-web.fm-dev.thecover.cn/reportInstructions/${id}`)
          } else {
            window.open(`https://www.scjb.gov.cn/reportInstructions/${id}`)
          }
        },
  },
}
</script>
<style lang="less" scoped>
.reporting-container {
  width: 100%;
  height: 100%;
  background-color: #f9f9f9;

  .reporting-title {
    text-align: left;
    background: linear-gradient( 201deg, #00A6F9 0%, #006DF1 100%);
    font-size: 1rem;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #fff;
    line-height: 2rem;
    height: 2rem;
    padding-left: 0.5rem;
  }
  
  .reporting-list {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    height: calc(100% - 2rem);
  }
  .reporting-list-item {
    width: 8.5556rem;
    height: 4.3333rem;
    margin-top: .3333rem;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
      border: #002FA7 1px solid;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>